import * as TYPES from './workflow-actiontypes';

export const setIsDedicatedWorkflow = (isDedicatedWorkflow) => ({
  type: TYPES.SET_ISDEDICATED_WORKFLOW,
  isDedicatedWorkflow,
});